// extracted by mini-css-extract-plugin
export default {"formTitle":"tmEU0h","button":"IbeEg7","buttonRow":"bJFo6B","deleteButton":"sx6V3K"};